import {SaveButton} from '@/components/refinedev/action_buttons';
import ProjectContractForm from './project_contract-form';
import CreateForm from '@/components/refinedev/pages/create-form';
import Section from '@/components/surface/Section';

const ProjectContractCreate = () => {
  return (
    <CreateForm transformBeforeSave={ProjectContractForm.transformBeforeSave}>
      <Section
        title="Thông tin hợp đồng"
        bodyProps={{className: 'flex flex-col gap-2'}}
        className="w-3/4 mx-auto">
        <ProjectContractForm.GeneralInfo />
      </Section>
      <SaveButton />
    </CreateForm>
  );
};

export default ProjectContractCreate;
